export const userRoles = {
    SUPERADMIN: "Superadmin",
} as const;

export type UserRole = keyof typeof userRoles;